"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _formatBanner = require("../../utils/formatBanner");
var _reportUtil = require("../../utils/reportUtil");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const _require = require('@tencent/cms-design-component'),
  StudentCenterBanner = _require.StudentCenterBanner;
const formatStudentCenterBanner = (properties, options = {}) => {
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString;
  const value = (0, _formatBanner.formatBannerCommon)(properties, options);
  const anchorList = (value.anchor || []).map((item, index) => {
    const _item$href = item.href,
      href = _item$href === void 0 ? '' : _item$href;
    const formattedHref = formatUrlString(href);
    return _objectSpread(_objectSpread({}, item), {}, {
      href: formattedHref,
      extendProps: {
        'report-event': 'click_student_son_banner_button',
        'report-ext1': index,
        'report-ext2': item.title,
        'report-ext3': formattedHref
      }
    });
  });
  value.anchor = anchorList;
  return value;
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatStudentCenterB = formatStudentCenterBanner(data, {
        domains
      }),
      title = _formatStudentCenterB.title,
      content = _formatStudentCenterB.content,
      _formatStudentCenterB2 = _formatStudentCenterB.backgroundUrl,
      backgroundUrl = _formatStudentCenterB2 === void 0 ? '' : _formatStudentCenterB2,
      _formatStudentCenterB3 = _formatStudentCenterB.backgroundUrlLogo,
      backgroundUrlLogo = _formatStudentCenterB3 === void 0 ? '' : _formatStudentCenterB3,
      _formatStudentCenterB4 = _formatStudentCenterB.backgroundVideoUrl,
      backgroundVideoUrl = _formatStudentCenterB4 === void 0 ? '' : _formatStudentCenterB4,
      lightTheme = _formatStudentCenterB.lightTheme,
      buttonList = _formatStudentCenterB.buttonList,
      liveType = _formatStudentCenterB.liveType,
      _formatStudentCenterB5 = _formatStudentCenterB.anchor,
      anchor = _formatStudentCenterB5 === void 0 ? [] : _formatStudentCenterB5;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      className: "gems-materials-qci__student-center-banner"
    }, (0, _reportUtil.reportShow)(['show_studentCenterBanner', componentKey, title])), /*#__PURE__*/React.createElement(StudentCenterBanner, {
      title: title,
      content: content,
      backgroundUrl: backgroundUrl,
      backgroundUrlLogo: backgroundUrlLogo,
      backgroundVideoUrl: backgroundVideoUrl,
      lightTheme: lightTheme,
      buttonList: buttonList,
      liveType: liveType,
      anchor: anchor,
      onCallback: item => {
        window.asyncReceiveCommodity(item);
      }
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}